import { $axios } from '../plugins/app-axios';

const user = {
    namespaced: true,
    state: {
        user: {},
    },
    getters: {
        getUser: state => state.user,
    },
    actions: {
        setUser: async ({ commit }, params) => {
            const { user } = (window as any).INIT_DATA;
            commit('setUser', { user });
        },
    },
    mutations: {
        setUser(state, payload) {
            state.user = payload.user;
        },
    },
};

export default user;
